type PasskeyRegistrationError = {
  code?: string | undefined;
  message?: string | undefined;
};

const cancelledErrorCodes = new Set([
  "AUTH_CANCELLED",
  "ERROR_CEREMONY_ABORTED",
]);

export function getPasskeyRegistrationError(
  error: PasskeyRegistrationError,
): string {
  if (
    cancelledErrorCodes.has(error.code ?? "") ||
    error.message?.includes("timed out or was not allowed")
  ) {
    return "Passkey registration was cancelled or timed out.";
  }

  if (error.code === "ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED") {
    return "This passkey is already registered.";
  }

  return error.message || "Unable to register this device.";
}
